/**
 */
define('constant/mysettings/mod.userinfo.constant',[], function () {
	return {
		myAccountChildMenu:{
			balance:61,
            earnings:62,
			server:63,
            newearnings:64,
            newearnings_settlement:641,
            newearnings_dispute:642,
            bills:65,
            bills_settlement:651,
            bills_dispute:652
		},
        myAccountChildMenuStates:{
            62:'MyAccount.earnings', //老收益菜单的路由
            64:'MyAccount.newEarnings'//新收益菜单的路由
        },
		mysetChildMenu : {
			userInfo : 71,
			bankInfo : 72,
			payInfo : 73,
            teamAccountInfo : 74
		},
		nopassTip : "【系统消息】您提交的开发者信息未通过审核，请参照下列审核意见进行修改：",
		autingTip:"【系统消息】您提交的开发者信息正在审核，请耐心等待。",
		commonTip : "审核时间大约需要1-2个工作日，如您有任何疑问请反馈至联盟邮箱devConnect@huawei.com。",
        noBankInfopassTip : "【系统消息】您提交的商户资料未通过审核，请参照下列审核意见进行修改：",
        noBankInfopassTipNew : "【系统消息】您提交的商户资料未通过审核，请参照商户服务页面的审核意见修改后重新提交申请。",
        autingBankTip:"【系统消息】您提交的商户资料正在审核，请耐心等待。",
        commonBankInfoTip : "审核时间大约需要1-2个工作日，如您有任何疑问请反馈至联盟邮箱devConnect@huawei.com。",
		noPayInfopassTip : "【系统消息】您提交的付费资料未通过审核，请参照下列审核意见进行修改：",
        autingPayTip:"【系统消息】您提交的付费资料正在审核，请耐心等待。",
        commonPayInfoTip : "审核时间大约需要1-2个工作日，如您有任何疑问请反馈至联盟邮箱devConnect@huawei.com。",
        noPassBecauseBank:"【系统消息】您提交的更名申请，由于银行信息审核不通过被驳回，请参照商户服务页面的审核意见修改后重新提交更名申请。",
        noPassBecauseBase:"【系统消息】您提交的更名申请，由于基础信息审核不通过被驳回，请参照开发者信息页面的审核意见修改后重新提交更名申请。",
        autingByNameChangeTip:"【系统消息】您提交的更名申请正在审核中，请耐心等待。",
        autingByNameChangeBussinessTip:"【系统消息】您提交的更名申请正在审核中，请等待审核完成后完善商户信息。",

        commonTipGm : "审核时间大约需要1-2个工作日，如您有任何疑问请反馈至联盟邮箱devConnect@huawei.com。",
        nopassTipGm : "您提交的开发者信息未通过审核，请参照下列审核意见进行修改：",
        noPassBecauseCNBank:"您提交的境内收款账户信息未通过审核，请参照下面审核意见进行修改：",
        noPassBecauseENBank:"您提交的跨境收款账户信息未通过审核，请参照下面审核意见进行修改：",
		autingNewSmrz:"您的实名认证审核正在处理，预计1-2个工作日完成。",
		autingNewCorpaSmrz:"您已提交对公银行打款实名认证，请您及时进行打款验证。",

		validMsg:{
			validPhone:{formatError:"手机号码格式不对",waitValid:"手机号码待验证"},
			validCorpName:{formatError1:"企业全称格式不对",formatError2:"企业全称不可包含特殊字符和空格"}
		},
		corUserType:{
			simpleCertification:"企业用户（简化实名认证）",
			commonCertification:"企业用户"
		},
		bussnessTabs:['银行信息','税务信息','联系人信息'],
		serviceState:['未完成','银行信息、税务信息、联系人信息都已填写'],
		bussinessState:['商户服务未开通','商户服务审核中','商户服务已开通'],
		payState:['付费服务未开通','付费服务已开通'],
        //默认过滤的url
        notSwitchUrl:['nameChangeCorp.','nameChangeCorp.userInfoCorp','nameChangeCorp.modBussnessInfo','nameChangeCorp.modInvoice','nameChangeCorp.submitSuccess','nameChangePer',
			'nameChangePer.userInfoPer','nameChangePer.modBussnessInfo','nameChangePer.modInvoice','nameChangePer.submitSuccess'],
        nameChangeUrl:["nameChangeCorp.userInfoCorp","nameChangeCorp.modBussnessInfo","nameChangeCorp.modInvoice","nameChangeCorp.submitSuccess",
			"nameChangePer.userInfoPer","nameChangePer.modBussnessInfo","nameChangePer.modInvoice","nameChangePer.submitSuccess"],
		accountNameEqTip:{
			eqTip:'开户名须与营业执照上企业全称一致，如需修改请重新修改实名认证信息。',
			notEqTip:'开户名须与企业营业执照上企业全称一致，请修改。'
		},
        //动态校验规则下的
        errorMsg: {
			/* 特殊国家的字段placeHolds 保证key和值不等*/
			/*阿根廷境外规则*/
            "AR_attribute4": "CBU的第1-3位与银行号一致，CBU的第4-7位与支行号一致。 CBU的12-21位与10个字符的帐号一致，CBU的9-22位与14个字符的帐号一致。",
            "AR_AccountNumber": "花旗银行账户等于10个字符，并且与CBU的第12-21位一致。 其他银行账户等于14个字符，与CBU的第9-22位一致。",
			/*波兰境内外规则*/
            "PL_iban": "IBAN的5号-12位与支行号一致。",
			/*哥斯达黎加境外规则*/
            "CR_iban": "IBAN的第6-8位与银行号一致，IBAN的第9-11位与支行号一致。",
			/*加蓬境内外规则*/
            "GA_accountNumber": "帐号的1-5位与支行号一致。",
			/*捷克境外规则*/
            "CZ_iban": "IBAN的5-8位与银行号一致。",
			/*斯洛伐克境内外规则*/
            "SK_iban": "IBAN的5-8位与银行号一致。",
			/*突尼斯境内外规则*/
            "TN_accountNumber": "帐号的1-5位与支行号一致。",
			/*新西兰境内外规则*/
            "NZ_accountNumber": "帐号的1-6位与支行号一致。",
			/*匈牙利境内外规则*/
            "HU_iban": "IBAN的5-12位与支行号一致。",
			/*英国境内外规则*/
            "GB_iban": "IBAN的9-14位与分行号一致。",

            /*秘鲁境外规则*/
            "PE_accountNumber": "请输入受益人帐号。花旗银行帐号为10位，其他银行帐号为20位。",
            /*阿联酋（海湾）境内外规则*/
            "AE_accountNumber": "当SWIFT代码以ABDIEAD开头时，请输入8位帐号；当SWIFT代码以EBILAEAD或MEBLAEAD开头时，请输入13位帐号。",
            /*智利境内 境内外规则*/
            "CL_accountNumber": "请输入少于15个字符的受益人帐号。BBVA银行帐号为18位，需删除前四位0504。",
            /*几内亚境境内外规则*/
            "GN_accountNumber": "请输入受益人帐号。经济银行帐号应包含16位数字，其它银行帐号应包含18位数字，与RIB上帐号相同。",
            /*卢旺达境境内外规则*/
            "RW_accountNumber": "请输入受益人帐号。经济银行帐号应包含16个字符。",
            /*沙特阿拉伯境内外规则*/
            "SA_accountNumber": "请输入受益人帐号。当SWIFT代码为ARNBSARI时，ANB银行帐号应为16位。其它银行应为24位IBAN号。",
            /*萨尔瓦多境内外规则*/
            "SV_accountNumber": "请输入受益人帐号。当银行代码为009, SWIFT代码为BACUSVSS时，帐号应为15位。当银行代码为037, SWIFT代码为CITIUS33ELR时，帐号应为10位。",
        },
        //fields显示的内容
        fields: {
            //阿根廷
            "AR_attribute4": "CBU",
            //秘鲁
            "PE_attribute4": "特殊国内银行账户",
            //瑞典
            "SE_attribute4": "GIRO号",
            //乌克兰
            "UA_attribute4": "完整帐号",
            //塔吉克斯坦
            "TJ_attribute4": "完整帐号",
            "CI_attribute4": "完整帐号"
        },
        tips: {
            "AR_attribute4": "受益人CBU号。",
            "PE_attribute4": "11位数字的国家银行特殊账户。不足的部分用前导零填充。如果此账户不存在，请替换为000000000000。此账户是每个企业的特殊税收账户，与正常的供应商银行账户不同。",
            "SE_attribute4": "受益人转帐号码。",
            "UA_attribute4": "银行转帐账户。",
            "TJ_attribute4": "银行转帐账户。"
        },
        accountTypes: ['SAVINGS', 'CHECKING', 'CURRENT A/C', 'DEPOSIT A/C', 'OTHER'],

        branchNumbeToNewNameByCountry :{
            /*澳大利亚 branch number换名字*/
            "AU": "BSB code",
            /*阿塞拜疆 branch number换名字*/
            "AZ": "MFO code",
            /*加拿大 branch number换名字*/
            "CA": "Transit code",
            /*科特迪瓦 branch number换名字*/
            "CI": "RIB",
            /*中国 branch number换名字   中国的先不改*/
            //"CN": "联行号",
            /*印度 branch number换名字*/
            "IN": "IFSC code",
            /*马拉维 branch number换名字*/
            "MW": "Sort code",
            /*纳米比亚 branch number换名字*/
            "NA": "Sort code",
            /*斯威士兰 branch number换名字*/
            "SZ": "Short code",
            /*美国 branch number换名字*/
            "US": "ABA number",
            /*越南 branch number换名字*/
            "VN": "CITAD code"
        },
        sceneList: [
            {
                label: 'APP',
                value: '1',
                isChecked: false,
            },
            {
                label: 'PC网站',
                value: '2',
                isChecked: false,
            },
            {
                label: '其他',
                value: '3',
                isChecked: false,
            },
        ]
	}
});

